import React, {useState} from 'react'
import {GoogleLogin} from 'react-google-login';
import Google_Ico from './google.png'
import {showToast} from '../../../../../Component/Toast';
import Spinner from '../../../../../Component/Loader'
import useClientHook from '../../../../../Hooks/useClientHook';

function Index(props) {

    const [Loader, setLoader] = useState();
    const [ErrorPage, setErrorPage] = useState();
    let {client_id} = useClientHook('LOGIN')

    const responseGoogle = (response) => {
        console.log(response);
        if(response.code){
            const form = document.createElement('form');
            form.method = "post";
            form.action = "https://auth.dice.tech/auth/employee/sso";

            let params = {
                type: 'google',
                token: response.code,
                referrer: window.location.origin,
                redirect: 'https://oauth.dice.tech',
                ...(client_id ? {client_id: client_id} : undefined)
            }

            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = key;
                    hiddenField.value = params[key];
                    form.appendChild(hiddenField);
                }
            }
            document.body.appendChild(form);
            try {
                setLoader(true)
                form.submit();
            } catch (err) {
                setLoader(undefined)
                showToast({
                    type: 'error',
                    message: err.response ? err.response.data.message : "Something went Wrong !"
                })
            }
        }else{
            setErrorPage(true)
        }
    }

    if(ErrorPage){
        return (
            <div style={{width: '100%', height: '100vh', display: 'flex', background: '#fff', justifyContent: 'center', alignItems: 'center'}}>
                <div className='text-center'>
                    <img className='mb-2' src={Google_Ico} style={{maxWidth: '80px'}} alt=""/>
                    <h1 className='display-6 fw-bold'>No Token</h1>
                    <p>There was a problem in google authentication</p>
                </div>
            </div>
        )
    }
    
    if (Loader || !client_id) {
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
	}

    return ( 
        <div className='p-5 text-center' style={{
            margin: 'auto',
            backgroundColor: '#fff',
            borderRadius: '1rem',
            width: '100%',
            minWidth: '280px',
            height:'100vh',
            display:'flex',
            justifyContent:'center',
            alignItems: 'center'
        }}>
            <div>
                <img className='mb-4' src={Google_Ico} style={{maxWidth: '80px'}} alt=""/>
                <h1 className='display-6 fw-bold'>Continue</h1>
                <p style={{marginBottom: '40px'}}>You have SSO enabled for your account</p>

                <GoogleLogin
                    clientId="577109105568-e65ha2mpib84tua3o06b2qrjnldosutk.apps.googleusercontent.com"
                    onSuccess={responseGoogle}
                    accessType="offline"
                    uxMode="popup"
                    approvalPrompt="force"
                    prompt='consent'
                    loginHint={props.data.username}
                    responseType="code"
                    onFailure={responseGoogle}
                    cookiePolicy={'single_host_origin'}/>

                <div style={{
                    fontSize: '12px',
                    background: '#0d6efd',
                    color: '#fff',
                    padding: '12px 14px',
                    width: '180px',
                    borderRadius:'5px',
                    margin: 'auto',
                    marginTop: '15px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'space-between',
                    cursor: 'pointer'
                }}
                onClick={()=>window.location.replace(`https://oauth.dice.tech?temp_login=${props.data.username}`)}
                >
                    <svg style={{fontSize:'16px'}} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"></path>
                    </svg>
                    Use One-Time Pasword
                </div>
            </div>
        </div>
     );
}

export default Index;
